module.exports = __webpack_public_path__ + "img/56.e3ee17c2.png";